import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Search, Heart, Shield, Rocket } from 'lucide-react';

const TeamPage = () => {
  const teamQualities = [
    {
      icon: <Search className="w-10 h-10 text-gold" />,
      title: 'Une obsession du bon match',
      description: 'Nous cherchons plus qu’un profil. Nous cherchons la personne qui fera vibrer l’équipe.',
    },
    {
      icon: <Heart className="w-10 h-10 text-gold" />,
      title: 'Une écoute active et bienveillante',
      description: 'Chaque talent mérite d’être compris. Chaque entreprise mérite d’être accompagnée.',
    },
    {
      icon: <Shield className="w-10 h-10 text-gold" />,
      title: 'Une expertise pointue',
      description: 'Notamment dans le secteur de l’assurance de dommages, où nous parlons votre langage et comprenons vos enjeux.',
    },
    {
      icon: <Rocket className="w-10 h-10 text-gold" />,
      title: 'Une énergie tournée vers l’avenir',
      description: 'Nous ne recrutons pas pour aujourd’hui. Nous construisons les équipes de demain.',
    },
  ];

  return (
    <div className="pt-16">
      {/* Hero Section */}
      <section className="relative min-h-[60vh] flex items-center justify-center bg-gradient-to-br from-[#1a1a1a] via-[#2a2a2a] to-[#1a1a1a] overflow-hidden">

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-display font-bold text-white mb-6">
            Notre équipe
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto">
            Des recruteurs engagés. Des artisans du lien.
          </p>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xl text-gray-700 leading-relaxed mb-6">
            Chez Nexor Talents, nous ne sommes pas de simples intermédiaires.
          </p>
          <p className="text-xl text-gray-700 leading-relaxed mb-6">
            Nous sommes des passionnés du potentiel humain, des stratèges du recrutement, et surtout, des partenaires de confiance.
          </p>
          <p className="text-xl text-gray-700 leading-relaxed">
            Notre équipe est composée de professionnels aux parcours variés — experts en ressources humaines, spécialistes sectoriels, conseillers en développement de carrière — tous animés par une même mission : <span className="font-semibold text-gold">créer des connexions qui ont du sens.</span>
          </p>
        </div>
      </section>

      {/* Ce qui nous unit */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-16 text-center">
            Ce qui nous unit
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {teamQualities.map((quality) => (
              <Card key={quality.title} className="card border-0 shadow-xl hover:shadow-2xl bg-white">
                <CardContent className="p-8">
                  <div className="flex items-start space-x-6">
                    <div className="flex-shrink-0">
                      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10">
                        {quality.icon}
                      </div>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-3">
                        {quality.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed text-lg">
                        {quality.description}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* En coulisses */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-12 text-center">
            En coulisses, mais toujours connectés
          </h2>
          <div className="space-y-6 text-center">
            <p className="text-xl text-gray-700 leading-relaxed">
              Nous travaillons avec agilité, proximité et réactivité.
            </p>
            <p className="text-xl text-gray-700 leading-relaxed">
              Basés au Québec, nous accompagnons nos clients et candidats partout où les talents veulent faire la différence.
            </p>
          </div>
        </div>
      </section>

      {/* Closing Statement */}
      <section className="py-24 bg-gradient-to-br from-[#1a1a1a] to-[#2a2a2a] text-white relative overflow-hidden">

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-display font-bold mb-8 text-gold">
            Nexor Talents
          </h2>
          <p className="text-2xl text-gray-300">
            C'est une équipe qui croit en vous — avant même que vous y croyiez vous-même.
          </p>
        </div>
      </section>
    </div>
  );
};

export default TeamPage;